import { Package, Receipt, ArrowRight } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";

const INVENTORY_LABEL = {
  pickup: { label: "Ritiro", color: "text-[#002FA7]", bg: "bg-blue-50/60", border: "border-[#002FA7]/30" },
  release: { label: "Riconsegna", color: "text-amber-700", bg: "bg-amber-50/60", border: "border-amber-300" },
};

const PROFORMA_LABEL = {
  standard: { label: "Standard", color: "text-zinc-600", bg: "bg-zinc-50", border: "border-zinc-200" },
  storage_deposit: { label: "Deposito", color: "text-[#002FA7]", bg: "bg-blue-50/60", border: "border-[#002FA7]/30" },
  storage_release: { label: "Riconsegna", color: "text-amber-700", bg: "bg-amber-50/60", border: "border-amber-300" },
};

export function RelatedDocsList({ relatedDocs, navigate }) {
  const { inventories = [], proformas = [] } = relatedDocs;

  return (
    <div className="space-y-3 text-sm" data-testid="related-docs-list">
      {inventories.length > 0 && (
        <div className="space-y-1.5">
          <div className="text-[10px] uppercase tracking-wider text-zinc-400 font-semibold">Inventari ({inventories.length})</div>
          {inventories.map((inv) => {
            const meta = INVENTORY_LABEL[inv.inventory_type] || INVENTORY_LABEL.pickup;
            return (
              <button
                key={inv.id}
                onClick={() => navigate(`/inventories/${inv.id}`)}
                data-testid={`related-inventory-${inv.id}`}
                className={`w-full text-left px-3 py-2 rounded-sm border ${meta.border} ${meta.bg} hover:brightness-95 transition flex items-center gap-2`}
              >
                <Package className={`w-4 h-4 ${meta.color} shrink-0`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="font-mono text-xs">{inv.number || "BOZZA"}</span>
                    <span className={`text-[9px] font-semibold uppercase tracking-wider ${meta.color}`}>{meta.label}</span>
                    <StatusBadge status={inv.status} />
                  </div>
                </div>
                <ArrowRight className="w-3.5 h-3.5 text-zinc-400 shrink-0" />
              </button>
            );
          })}
        </div>
      )}

      {proformas.length > 0 && (
        <div className="space-y-1.5">
          <div className="text-[10px] uppercase tracking-wider text-zinc-400 font-semibold">Fatture Proforma ({proformas.length})</div>
          {proformas.map((pf) => {
            const meta = PROFORMA_LABEL[pf.proforma_type] || PROFORMA_LABEL.standard;
            return (
              <button
                key={pf.id}
                onClick={() => navigate(`/proformas/${pf.id}`)}
                data-testid={`related-proforma-${pf.id}`}
                className={`w-full text-left px-3 py-2 rounded-sm border ${meta.border} ${meta.bg} hover:brightness-95 transition flex items-center gap-2`}
              >
                <Receipt className={`w-4 h-4 ${meta.color} shrink-0`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="font-mono text-xs">{pf.number || "BOZZA"}</span>
                    {pf.proforma_type !== "standard" && (
                      <span className={`text-[9px] font-semibold uppercase tracking-wider ${meta.color}`}>{meta.label}</span>
                    )}
                    <StatusBadge status={pf.status} />
                  </div>
                </div>
                <ArrowRight className="w-3.5 h-3.5 text-zinc-400 shrink-0" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
